<template>
  <div>
    <md-table :value="users" md-height="100%"  md-sort="name" md-sort-order="asc" md-card md-fixed-header>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Users</h1>
          <router-link :to="{name: 'newuser'}">New User</router-link>
        </div>
      </md-table-toolbar>

      <md-table-empty-state
        md-label="No users found"
        :md-description="`No user found for this '${search}' query. Try a different search term or create a new user.`">
        <md-button class="md-primary md-raised" @click="newUser">Create New User</md-button>
      </md-table-empty-state>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="ID" md-sort-by="id">{{ item._id }}</md-table-cell>
        <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
       <md-table-cell md-label="Email" md-sort-by="email">{{ item.email }}</md-table-cell>
        <md-table-cell md-label="Role" md-sort-by="role">{{ item.role }}</md-table-cell>
        <md-table-cell md-label="Date" md-sort-by="date">{{ item.date }}</md-table-cell>
        <md-table-cell md-label="Actions">
          <router-link tag="md-button" :to="{ name: 'user', params: { id: item._id} }" class="md-icon-button md-dense md-raised md-primary">
             <md-icon><v-icon name="edit" /></md-icon>
          </router-link>
            <md-button @click="deleteItem(item)" class="md-icon-button md-dense md-raised md-accent">
              <md-icon><v-icon name="trash" /></md-icon>
            </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<style scoped>
</style>

<script>
const toLower = text => text.toString().toLowerCase();

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.name).includes(toLower(term)));
  }

  return items;
};

export default {
  name: 'TableSearch',
  data: () => ({
    search: null,
    searched: [],
  }),
  computed: {
    users() {
      return this.$store.state.users;
    },
  },
  mounted() {
    this.$store.dispatch('loadUsers');
  },

  methods: {
    newUser() {
      window.alert('Noop');
    },
    searchOnTable() {
      this.searched = searchByName(this.users, this.search);
    },
    deleteItem(user) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('deleteUser', user).then(() => {
            this.$swal.fire({
              position: 'top-end',
              type: 'success',
              title: 'User account has been deleted.',
              showConfirmButton: false,
              timer: 1500,
            });
          });
        }
      });
    },
  },
  created() {
    this.searched = this.users;
  },
};
</script>

<style lang="scss" scoped>
  .md-field {
    max-width: 300px;
  }
</style>
